module.exports = __webpack_public_path__ + "img/四川天府新区第九幼儿园.200a69bf.jpg";